<div class="flex items-center ml-2 gap-1">
    <app-select
        placeholder="allElements"
        [disableSelectAll]="true"
        [emptyOptionLabel]="'loading'"
        [isMultiSelect]="true"
        [options]="layerNamesOptions()"
        [sortOptions]="false"
        [(selectedOptions)]="selectedLayersOptions"
        (optionSelected)="onSearch(true)" />

    <div class="flex items-center px-2 border border-solid border-white gap-1 bg-on-primary rounded p-1">
        <fa-icon
            class="mr-2 text-gray-300 text-base"
            matIconPrefix
            size="lg"
            [icon]="['fas', 'search']" />
        <input
            #autoInput="matAutocompleteTrigger"
            class="w-96 border-none text-base placeholder:text-gray-400 outline-none"
            matInput
            type="text"
            [disabled]="isLoading()"
            [matAutocomplete]="autoGroup"
            [matAutocompleteDisabled]="!banSearchResults() && !projectSearchResults() && !searchValue().length"
            [matTooltip]="isLoading() ? ('loading' | transloco) : undefined"
            [placeholder]="labelKey() | transloco"
            [(ngModel)]="searchValue"
            (input)="onSearch()" />
        @if (searchValue().length) {
            <fa-icon
                class="mx-2 text-gray-300 text-sm cursor-pointer"
                matIconPrefix
                size="lg"
                [icon]="['far', 'xmark']"
                (click)="resetSearch()" />
        }
        <mat-autocomplete
            #autoGroup="matAutocomplete"
            panelWidth="429.5px"
            (opened)="setResultsPanelPosition()">
            @if (isEditMode()) {
                <app-edit-warn-message displayedMessage="editMode.currentEditNotIncludedInSearch" />
            }

            @if (banSearchResults()?.length) {
                <p class="!m-0 my-1 pl-4 text-on-surface text-base">{{ 'addressBAN' | transloco }}</p>
                @for (feature of banSearchResults()!; track $index) {
                    <mat-option
                        class="!pl-8 !min-h-8"
                        [value]="feature.label"
                        (click)="selectedAddressSearchItem(feature)">
                        {{ feature.label }}
                    </mat-option>
                }
            }
            @if (projectSearchResults()?.length) {
                <p class="!m-0 !mt-4 pl-4 text-on-surface text-base">{{ 'depositEntity' | transloco }}</p>
                @for (searchResultData of projectSearchResults()!; track searchResultData) {
                    <mat-option
                        class="!pl-8 !min-h-8"
                        [value]="searchResultData.name"
                        (click)="selectDataEntitySearchItem(searchResultData)"
                        ><span class="italic text-on-surface">{{ searchResultData.data.parentName }} -</span>
                        {{ searchResultData.name }}
                    </mat-option>
                }
            }
            @if (
                searchValue() &&
                (searchValue().length < minSearchLength ||
                    (searchValue().length >= minSearchLength &&
                        !banSearchResults()?.length &&
                        !projectSearchResults()?.length))
            ) {
                <mat-option
                    disabled="true"
                    [value]="'noSearchResults'"
                    >{{
                        (searchValue().length < minSearchLength ? 'minSearchLength' : 'noSearchResults')
                            | transloco: { value: minSearchLength }
                    }}
                </mat-option>
            }
        </mat-autocomplete>
    </div>
</div>
